export default __webpack_public_path__ + "static/media/welcome-tour-2.cf10e3d6.png";